import { render, staticRenderFns } from "./organizationalList.vue?vue&type=template&id=5188a0d9"
import script from "./organizationalList.vue?vue&type=script&lang=js"
export * from "./organizationalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports